"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dateFns = require("date-fns");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value;
    var productId = settings.productId;
    if (!value || !Array.isArray(value)) {
      console.error('LicenseStatus render is expecting an array of Owned Licenses as the value.');
      return /*#__PURE__*/_react["default"].createElement("span", null, "-");
    }
    if (value.length <= 0 || !value.some(function (lic) {
      return lic.productId === productId;
    })) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "-");
    }
    var requiredSubFields = ['expiresAt', 'isExpired', 'productId', 'licenseId'];
    if (!requiredSubFields.every(function (key) {
      return key in value[0];
    })) {
      console.error('Value for LicenseStatus must be an array of items with each of these subfields: ' + requiredSubFields.join(', '));
      return /*#__PURE__*/_react["default"].createElement("span", null, "-");
    }
    var activeLicense = value.find(function (lic) {
      return !lic.isExpired && lic.productId === productId;
    });
    if (activeLicense) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].date
      }, (0, _dateFns.format)((0, _dateFns.parse)(activeLicense.expiresAt), 'YYYY-MM-DD'));
    }
    var expiredLicense = value.find(function (lic) {
      return lic.isExpired && lic.productId === productId;
    });
    if (expiredLicense) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Expired");
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "-");
  };
};